import { Price, PriceKind, ProductBonus, UnitPrice } from '@product/const';

export function mapUnitPrices(unitPrices: UnitPrice[]): Price[] {
  const prices: Price[] = [];

  unitPrices.forEach((unitPrice) => {
    const saleUnit = unitPrice.saleUnit || unitPrice.unit;

    prices.push({
      ...unitPrice.price,
      unit: unitPrice.unit,
      kind: PriceKind.REGULAR,
      saleUnit,
    });

    if (unitPrice.crossedPrice) {
      prices.push({
        ...unitPrice.crossedPrice,
        unit: unitPrice.unit,
        kind: PriceKind.CROSSED,
        saleUnit,
      });
    }

    if (unitPrice.personalPrice) {
      prices.push({
        ...unitPrice.personalPrice,
        unit: unitPrice.unit,
        kind: PriceKind.PERSONAL,
        saleUnit,
      });
    }

    if (unitPrice.transitPrice) {
      prices.push({
        ...unitPrice.transitPrice,
        unit: unitPrice.unit,
        kind: PriceKind.TRANSIT,
        saleUnit,
      });
    }
  });

  return prices;
}

export function mapBonuses(unitPrices: UnitPrice[]): ProductBonus[] {
  const bonuses: ProductBonus[] = [];

  unitPrices.forEach((unitPrice) => {
    if (unitPrice.bonus) {
      bonuses.push({
        ...unitPrice.bonus,
        unit: unitPrice.unit,
      });
    }
  });

  return bonuses;
}
